import { render, staticRenderFns } from "./course-works.vue?vue&type=template&id=3295070a&scoped=true"
import script from "./course-works.vue?vue&type=script&lang=ts&setup=true"
export * from "./course-works.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./course-works.vue?vue&type=style&index=0&id=3295070a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3295070a",
  null
  
)

export default component.exports